import { AppState } from '../index';
import { ISearchSynonymState } from './types';

export const searchSynonymStateSelector = ({ searchSynonymState }: AppState): ISearchSynonymState => searchSynonymState;

export const uploadPercentageSelector = ({ searchSynonymState }: AppState): number =>
  searchSynonymState?.progressPercentage || 0;
export const uploadFileSelector = ({ searchSynonymState }: AppState): File => searchSynonymState?.file;
